import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _CopyIcon;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Fade } from '@mui/material';
import classNames from 'classnames';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { compose } from 'redux';
import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import ButtonBase from '@mui/material/ButtonBase';
import { CopyIcon } from '../statelessComponents/Icons';
import intlPropTypes from '../../constants/intlPropTypes';
var messages = defineMessages({
  successTitle: {
    id: "CopyToClipboard.successTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Copied"
    }]
  },
  hintTitle: {
    id: "CopyToClipboard.hintTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Copy to clipboard"
    }]
  }
});
var CopyToClipboard = function CopyToClipboard(_ref) {
  var formatMessage = _ref.intl.formatMessage,
    copyText = _ref.copyText,
    _ref$successTitle = _ref.successTitle,
    successTitle = _ref$successTitle === void 0 ? '' : _ref$successTitle,
    _ref$hintTitle = _ref.hintTitle,
    hintTitle = _ref$hintTitle === void 0 ? '' : _ref$hintTitle,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCopied = _useState2[0],
    setIsCopied = _useState2[1];
  var copyTextToClipboard = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(text) {
      var _document;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!('clipboard' in navigator)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", navigator.clipboard.writeText(text));
          case 2:
            return _context.abrupt("return", (_document = document) === null || _document === void 0 ? void 0 : _document.execCommand('copy', true, text));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function copyTextToClipboard(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleCopyClick = function handleCopyClick() {
    copyTextToClipboard(copyText).then(function () {
      setIsCopied(true);
      setTimeout(function () {
        setIsCopied(false);
      }, 1500);
    })["catch"](function (err) {
      console.error(err);
    });
  };
  if (children) {
    return /*#__PURE__*/_jsx("div", {
      className: classNames(className)
    }, void 0, /*#__PURE__*/_jsx(Tooltip, {
      TransitionComponent: Fade,
      TransitionProps: {
        timeout: 1000
      },
      title: successTitle || formatMessage(messages.successTitle),
      open: isCopied
    }, void 0, /*#__PURE__*/_jsx(ButtonBase, {
      "data-test-id": "E2YRoS1jFtwmR_N6QFz23",
      onClick: handleCopyClick
    }, void 0, children)));
  }
  return /*#__PURE__*/_jsx("span", {
    className: classNames(className)
  }, void 0, /*#__PURE__*/_jsx(Tooltip, {
    TransitionComponent: Fade,
    TransitionProps: {
      timeout: 1000
    },
    title: successTitle || formatMessage(messages.successTitle),
    open: isCopied
  }, void 0, /*#__PURE__*/_jsx(Tooltip, {
    title: isCopied ? '' : hintTitle || formatMessage(messages.hintTitle)
  }, void 0, /*#__PURE__*/_jsx(IconButton, {
    "data-test-id": "kSIwD1OqzRR72iDHNdIdO",
    onClick: handleCopyClick
  }, void 0, _CopyIcon || (_CopyIcon = /*#__PURE__*/_jsx(CopyIcon, {}))))));
};
export default compose(injectIntl)(CopyToClipboard);